enum OfflineSalesTitles {
  Impressions = 'Impressions',
  Reach = 'Reach',
  TotalSales = 'Total Records Uploaded',
  MatchedSales = 'Matched Records',
  MatchedConversions = 'Matched Conversions',
  ExtrapolatedConversions = 'Extrapolated Conversions',
  MediaSalesPercent = '% of Total Conversions From Media',
  UniqueCVR = 'Unique CVR',
}

export default OfflineSalesTitles;
